import React from "react";
import EditIcon from "@mui/icons-material/Edit";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import DescriptionIcon from "@mui/icons-material/Description";
import NextPlanIcon from "@mui/icons-material/NextPlan";
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import PublicIcon from '@mui/icons-material/Public';
import PeopleIcon from '@mui/icons-material/People';
import AnimationIcon from '@mui/icons-material/Animation';
export const menuItems = [
  {
    title: "DaoTrang",
    icon: <DescriptionIcon />,
    children: [
      {
        title: "List",
        icon: <FormatListNumberedIcon />,
        path: "DaoTrangList",
      },
      {
        title: "Members",
        icon: <PeopleIcon />,
        path: "DaoTrang",
      },
      {
        title: "Ban",
        icon: <PeopleIcon />,
        path: "BCS",
      },
      {
        title: "Tổ",
        icon: <PeopleIcon />,
        path: "To",
      },
      {
        title: "Thành Phần",
        icon: <PeopleIcon />,
        path: "TP",
      },
    ],
  }, {
    title: "CLB",
    icon: <PublicIcon />,
    children: [
      {
        title: "TNTC",
        icon: <LocalShippingIcon />,
        path: "TNTC",
      },
      {
        title: "FBBCS",
        icon: <EditIcon />,
        path: "FBBCS",
      },
    ],
  }
];
